// Copyright (c) 2017 Deere & Company

import PipProducts, {getDefaultState as getPipProductsDefaultState} from '../../shared/state/pip-products';
import actions from '../../actions-list';

export const readLaborAdditivePipProducts = (state, action) =>
    PipProducts.update(state, {
        $set: action.data
    });

export default (state = getPipProductsDefaultState(), action) => {

    const actionTypes = {
        [actions.READ_LABOR_ADDITIVE_PIP_PRODUCTS_SUCCESS]: readLaborAdditivePipProducts
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/pip/labor-additive/reducers/pip-products.js